module.exports = __webpack_public_path__ + "img/get-coupon-side-btn.f5a4ea26.png";